import React, { useState } from 'react';
import AnimatedNumberCounter from './animated-number-counter';
import { CarouselProvider } from '$contexts/carousel';
import Carousel, { CarouselSlide } from '$partials/ui/carousel';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ModuleStats}
 */

export const StatisticsItem = ({
    className,
    eyebrowTitle,
    statistic,
    body
}) => {
    const [progress, setProgress] = useState(-1);
    const rx = /(?<number>[\d|.,]+)|(?<text>[\D]+)/g;
    let matches;
    const output = [];

    while (matches = rx.exec(statistic)) {
        output.push(matches.groups);
    }

    const handleAnimationEnd = (i) => setProgress(i);
    let shouldRenderItem = true;
    return (
        <div className={`flex flex-col bg-surface-raised rounded justify-between items-center md:p-40 px-16 py-32 ${className}`}>

            {eyebrowTitle && (
                <p className='text-text-accent type-style-eyebrow'>
                    {eyebrowTitle}
                </p>
            )}
            <div className='flex flex-row mt-40'>
                {output.map((item, i) => {
                    if (!shouldRenderItem) { return null; }
                    const decimalPlaces = item?.number?.toString?.().split?.(/\.|,/)?.[1]?.length;
                    const result = (
                        item.number ? (
                            <div
                                className='relative type-style-large-number text-text-primary'
                                key={i}>
                                <div className='absolute'>
                                    <AnimatedNumberCounter
                                        decimalPlaces={decimalPlaces}
                                        onEnd={handleAnimationEnd.bind(null, i)}
                                        toValue={parseFloat(item.number)} />
                                </div>
                                <span className='opacity-0'>{item.number}</span>
                            </div>
                        ) : (
                            <span
                                className='type-style-large-number text-text-primary'
                                key={i}>{item.text}</span>
                        )
                    );

                    if (i > progress && item.number && shouldRenderItem) {
                        shouldRenderItem = false;
                    }
                    return result;
                })}
            </div>

            <p className='type-style-body text-text-secondary text-center mt-40'>{body}</p>
        </div>
    );
};

/**
 * @type {import('$types/components/partials/modules.d.ts').ModuleStats}
 */

const ModuleStats = ({
    isHomePage,
    header,
    itemsCollection,
    isArticlePage
}) => {
    const items = itemsCollection?.items;
    return (
        <section className={`relative overflow-hidden ${isHomePage ? 'pt-16 pb-40' : isArticlePage ? 'py-40' : 'py-40 md:py-80'}`}>
            <div className='layout-container layout-site-outer-padding'>

                <div className='bg-white'>
                    {header && (
                        <p className={`${isArticlePage ? 'type-style-4' : 'type-style-3-extended'}  mb-30`}>
                            {header}
                        </p>
                    )}

                    {/* Desktop */}
                    {items?.length > 0 && (
                        <div className={`gap-16 hidden sm:grid ${items?.length === 2 ? 'grid-cols-2' : 'grid-cols-3'}`}>
                            {items.map((item, i) =>
                                <StatisticsItem
                                    key={i}
                                    {...item} />
                            )}
                        </div>
                    )}

                    {/* Tablet / Mobile Carousel */}
                    <div className='overflow-hidden w-screen max-w-screen left-1/2 relative -translate-x-1/2 sm:hidden'>
                        <CarouselProvider>
                            <div className='layout-container layout-site-outer-padding'>
                                <div className='col-wrapper'>
                                    <Carousel className='flex swiper-wrapper h-auto w-full'>
                                        {items.map((item, i) => {
                                            if (!item) {return null;}
                                            return (
                                                <CarouselSlide
                                                    className='h-auto flex col-padding w-8/12'
                                                    index={i}
                                                    key={`stats-carousel-${i}`}>
                                                    <StatisticsItem
                                                        className='w-full'
                                                        key={i}
                                                        {...item} />
                                                </CarouselSlide>
                                            );})}
                                    </Carousel>
                                </div>
                            </div>
                        </CarouselProvider>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default ModuleStats;
